export enum OrganisationSettingEnum {
  JobAlertBeta = 1,
  MaxJobAlertsPerSupplierPerDay = 2,
  MaxJobWatchAlertsPerDay = 3, // Per supplier
  MinDeliveryWindow = 4, // Hours
  MinCollectionWindow = 5, // Hours
  TransportMode = 6, // Road, Air, Sea, Rail
  JobAlertsByMail = 7,
  JobAlertsBySMS = 8,
  DailySummaryByMail = 9,
  DailySummaryLogo = 10,
  RecommendedRoutesBeta = 11,
  BookingToolEnabled = 12,
  BookingToolPaymentRequired = 13,
  EnableLiveChat = 14,
  RecommendedRoutesMobileBeta = 15,
  TravelSchedulerMobileDisabled = 16,
  OrderApiQuoteExpiryHours = 17,
  RelatedRoutePreviewDisabled = 18,
  DefaultToRouteSearch = 19,
  SupplierTravelPreferencesEnabled = 20,
  TaskCompleteCommsOnManualEdit = 21,
}
